module.exports = __webpack_public_path__ + "img/au.51c6ce94.svg";